import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const isAdminPath = (cfg.url || "").startsWith("/admin");
  const token = isAdminPath
    ? localStorage.getItem("admin_token")
    : localStorage.getItem("participant_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401) {
      if (url.startsWith("/admin")) {
        localStorage.removeItem("admin_token");
        if (!window.location.pathname.startsWith("/admin/login")) {
          window.location.href = "/admin/login";
        }
      } else if (url.startsWith("/participant") || url.startsWith("/prompts") || url.startsWith("/generate-prompt") || url.startsWith("/payments")) {
        localStorage.removeItem("participant_token");
        localStorage.removeItem("participant_email");
        if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/admin")) {
          window.location.href = "/login?expired=1";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Ralat tidak diketahui";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
